import React from "react";

const ApplicationStepHeader = ({ step, totalSteps }) => {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="mb-0">
          Step {step} of {totalSteps}
        </h5>
        <small className="text-muted">
          {step === 1 && "Tenant details"}
          {step === 2 && "Spouse & next of kin"}
          {step === 3 && "Landlord, pets & vehicles"}
          {step === 4 && "References & source of funds"}
        </small>
      </div>
      <div className="mb-4">
        <div className="progress" style={{ height: "6px" }}>
          <div
            className="progress-bar"
            role="progressbar"
            style={{ width: `${(step / totalSteps) * 100}%` }}
            aria-valuenow={step}
            aria-valuemin="1"
            aria-valuemax={totalSteps}
          />
        </div>
        <div className="d-flex justify-content-between mt-1 small text-muted">
          <span>Tenant</span>
          <span>Spouse / Kin</span>
          <span>Landlord / Pets</span>
          <span>Refs / Funds</span>
        </div>
      </div>
    </>
  );
};

export default ApplicationStepHeader;


